import React, { Component } from 'react';
import { PaddedBlock } from './components/atoms';
import { HeaderView, FooterView, AppointmentBookingView } from './components/views';

class BookMeetingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <main>
        <HeaderView opaque={true} />
        <PaddedBlock padding={80} />
        <AppointmentBookingView />
        <FooterView />
      </main>
    );
  }
}

export default BookMeetingPage;
